import React from "react";
import S from './HallLayout.module.scss';

interface HallLayoutProps {
    img?: string;
}

export const HallLayout = ({ img }:HallLayoutProps ) => {
    return (
        <div className={S.contentDiv}>
            <div className={S.title}>СХЕМА ЗАЛА</div>
            <div className={S.picture}>
                <img src={img} alt="hallLayout"/>
            </div>
        </div>
    );
};